export default "__VITE_ASSET__BB$BMFTp__"